import { atom, useRecoilState } from "recoil";
import {
  PointTabBar,
  PointTabColumn,
  PointTabContainer,
  PointTabText,
} from "../../Benefit/Point/PointTab";
import React from "react";
import styled from "styled-components";

export const matchMakingPartyTabState = atom<number>({
  key: "matchMakingPartyTabState",
  default: 0,
});

export default function MatchMakingPartyTab() {
  const [tab, setTab] = useRecoilState(matchMakingPartyTabState);

  return (
    <PointTabContainer>
      <PointTabColumn onClick={() => setTab(0)}>
        <PointTabText isActive={Boolean(tab === 0)}>파티 관리</PointTabText>

        <MatchMakingPartyTabBar tab={tab} />
      </PointTabColumn>

      <PointTabColumn onClick={() => setTab(1)}>
        <PointTabText isActive={Boolean(tab === 1)}>이메일 관리</PointTabText>
      </PointTabColumn>
    </PointTabContainer>
  );
}

const MatchMakingPartyTabBar = styled(PointTabBar)`
  width: ${({ tab }) => (tab === 0 ? 70 : 85)}px;
  left: ${({ tab }) => (tab === 0 ? 0 : 85)}px;
`;
